import { FormProvider } from 'dash-ui';

import AccountInfoForm from './components/AccountInfoForm/AccountInfoForm';
import { FormFieldsList } from './components/AccountInfoForm/AccountInfoForm.constants';
import { CropImageModal } from './components/AccountInfoForm/components/CropImageModal';

const AccountInfo = () => (
  <FormProvider fieldsList={FormFieldsList}>
    <AccountInfoForm />
    <CropImageModal />
  </FormProvider>
);

export default AccountInfo;
